var render = function render(){var _vm=this,_c=_vm._self._c;return _c('summary-count',{attrs:{"title":"Delayed Start","is-loading":_vm.isLoading,"count":_vm.count,"count-class":'tw-text-red-500',"caption":'Needs Follow-Up',"caption-class":'tw-text-red-500',"clickable":true},on:{"cardClicked":_vm.gotoPrescriptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }